module.exports = __webpack_public_path__ + "11f0d8d565b6924a449a14605c2e88d4.svg";